import { motion } from 'motion/react';
import { useIsDesktop } from '@firsttable/web-theme';
import { cn } from '@discover-lib/utils';
import useDiscountOnly from '@discover-data/stores/hooks/discountOnly/useDiscountOnly';
import { ToggleGroup, ToggleGroupItem, type ToggleGroupProps } from '@discover-ui/toggleGroup';

export type DiscountOnlySwitchProps = Omit<
  ToggleGroupProps,
  'type' | 'value' | 'onValueChange' | 'defaultValue'
>;

export default function DiscountOnlySwitch({ className, ...props }: DiscountOnlySwitchProps) {
  const [discountOnlyStoreValue, setDiscountOnly] = useDiscountOnly();
  const isDesktop = useIsDesktop();

  const handleValueChange = (value: string) => {
    setDiscountOnly(value === 'discountOnly');
  };

  return (
    <ToggleGroup
      type="single"
      value={discountOnlyStoreValue ? 'discountOnly' : 'allTables'}
      onValueChange={handleValueChange}
      className={cn('rounded-md bg-gray-100 p-1', className)}
      {...props}>
      <ToggleGroupItem
        value="discountOnly"
        kind="white-transparent"
        scale={isDesktop ? 'md' : 'sm'}
        aria-label="Toggle 50% Off"
        className="relative flex-1 bg-transparent font-medium text-blue data-[state=on]:bg-white data-[state=on]:text-blue data-[state=on]:shadow-sm">
        <span className="relative z-20">50% Off</span>
        {discountOnlyStoreValue && (
          <motion.span
            layoutId="bubble"
            className="absolute inset-0 z-10 rounded bg-white "
            transition={{ type: 'spring', bounce: 0.2, duration: 0.6 }}
          />
        )}
      </ToggleGroupItem>
      <ToggleGroupItem
        value="allTables"
        kind="white-transparent"
        scale={isDesktop ? 'md' : 'sm'}
        aria-label="Toggle All Tables"
        className="relative flex-1 bg-transparent font-medium text-blue data-[state=on]:bg-white data-[state=on]:text-blue data-[state=on]:shadow-sm">
        <span className="relative z-20">All Tables</span>
        {!discountOnlyStoreValue && (
          <motion.span
            layoutId="bubble"
            className="absolute inset-0 z-10 rounded bg-white "
            transition={{ type: 'spring', bounce: 0.2, duration: 0.6 }}
          />
        )}
      </ToggleGroupItem>
    </ToggleGroup>
  );
}
